import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

export default function StatsCard({ icon, label, value, color, link, entityType }) {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate based on entity type
    switch (entityType) {
      case 'songs': navigate('/song-database-list');
        break;
      case 'musicals': navigate('/all-musicals');
        break;
      case 'roles': navigate('/all-roles');
        break;
      case 'talent': navigate('/talent-management-dashboard');
        break;
      default:
        break;
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full text-left group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 border border-gray-100 hover:border-purple-200 transform hover:-translate-y-1 cursor-pointer"
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 bg-gradient-to-br from-purple-500 to-blue-500 rounded-xl group-hover:from-purple-600 group-hover:to-blue-600 transition-all duration-200`}>
          <Icon name={icon} size={24} className="text-white" />
        </div>
      </div>
      
      <div>
        <p className="text-2xl font-heading font-bold text-gray-900 mb-1">
          {typeof value === 'number' ? value?.toLocaleString() : value}
        </p>
        <h3 className="text-lg font-medium text-gray-700 mb-2">{label}</h3>
        <p className="text-sm text-gray-500">{entityType}</p>
      </div>
    </button>
  );
}